<template>
    <div :class="`rn-accordion-style rn-accordion-02 accordion`">
        <div class="accordion" >
            <div class="accordion-item card" v-for="(content, index) in accordionContent">

              <a style="cursor: pointer;padding-left: 15px;color: #65676b" target="_blank"  :href="content.attachUrl">{{index+1}}、{{ content.attachName }}</a>

            </div>
        </div>

      <Pagination
          @change="changePage"
          :current="queryParams.pageNum"
          :pageSize="queryParams.pageSize"
          :total="total"
          :hideOnSinglePage="true"
          :showQuickJumper="true"
          :showTotal="true"
          placement="center"
      />
    </div>
</template>

<script>
import Pagination from "../../components/elements/page/Pagination";
    export default {
        name: 'ProductDownloadAccordion',
        components: {Pagination},
        props: {
            id: {
                type: String,
                default: 'accordionExample'
            },
            accordionStyleClass: {
                type: String
            },

        },
        data() {
            return {
              total: 0,
              queryParams: {
                pageNum: 1,
                pageSize: 10,
              },
              accordionContent:[],
              activeCollapse: 0
            }
        },
      created() {
        this.getDownloadAttach(this.queryParams);
      },
      methods:{
        getDownloadAttach(data){
          this.postRequest('/system/web/listAttach',data).then(resp => {
            this.accordionContent = resp.data.rows;
            this.accordionContent.forEach(item=>{
              item.attachUrl = process.env.VUE_APP_BASE_API + item.attachUrl;
            })
            this.total = resp.data.total;
          })
        },
        changePage(pager){
          this.queryParams.pageNum = pager.page;
          this.queryParams.pageSize = pager.pageSize;
          this.getDownloadAttach(this.queryParams);
        }
      }
    }
</script>